import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import userStore from './user.store'
import editorStore from './editor.store'
const store = new Vuex.Store({
  modules: {
    userStore,
    editorStore
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {}
})

export default store
